module.exports = __webpack_public_path__ + "static/media/account.13d74bbc.svg";